import { render, staticRenderFns } from "./RoleListAddNew.vue?vue&type=template&id=387c901a&"
import script from "./RoleListAddNew.vue?vue&type=script&lang=js&"
export * from "./RoleListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./RoleListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports